
import { Component, Vue, Watch } from "vue-property-decorator";
import Unity from "vue-unity-webgl";
import { Getter } from "vuex-class";
import { Language } from "@/models/Language";
import api from "@/network/api";
import { AxiosError, AxiosResponse } from "axios";
import { Route } from "vue-router";
import IepUnity from "../../components/ui/IepUnity.vue";

@Component({
  components: {
    Unity,
    IepUnity,
  },
})
export default class GameRoomPage extends Vue {
  @Getter("userLanguageId") private currentLanguage!: Language;
  @Getter("userName") private userName!: string;
  @Getter("userRawAvatar") private userRawAvatar!: string;
  @Getter("userFirstName") private userFirstName!: string;
  @Getter("userLastName") private userLastName!: string;
  @Getter("userEmail") private userEmail!: string;
  @Getter("userId") private userId: string;
  game: any = {};
  gameReady = false;
  originalAlert: any = null;

  beforeCreate() {
    try {
      delete (window as any).unityInstance;
    } catch (ex) {
      console.debug(ex);
    }
  }
  created() {
    const gameId = this.$route.query.game;
    this.gameReady = false;
    api
      .get("/games/" + gameId)
      .then((res: AxiosResponse) => {
        this.game = res.data.game;
        this.gameReady = true;
        this.originalAlert = alert;
        window.alert = function(message){
          console.warn("custom warning ==> ",message);
        }
        this.registerWindowFunction();
      })
      .catch((err: any) => {
        if (err.status == 403) {
          this.$router.push("/booths");
        } else {
          console.error(err);
        }
      });
  }

  @Watch("$route")
  ifGameIdChanges(route: Route) {
    if (route.query.game !== this.game.id) {
      location.reload();
    }
  }

  registerWindowFunction() {
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    window.communicateWithWeb = async (request: string, callback: any) => {
      const req = JSON.parse(request);
      let res = {};
      if (req.type == "getLanguage") {
        res = {
          type: "getLanguage",
          data: {
            language: this.currentLanguage.code == "en" ? "English" : "Arabic",
          },
        };
      } else if (req.type == "submitScore") {
        const score = req.data.score ? req.data.score : req.data.Score;
        const hash = this.calculateHash(score);
        // submitScore to the API
        api
          .post("/game_scores", {
            score: score,
            hash: hash,
            game: this.game.id,
          })
          .then()
          .catch();

        res = {
          statusCode: 200,
          type: "submitScore",
          data: {},
        };
      } else if (req.type == "getUserProfile") {
        res = {
          type: "getUserProfile",
          data: {
            username: this.userName,
            email: this.userEmail,
            // eslint-disable-next-line @typescript-eslint/camelcase
            first_name: this.userFirstName,
            // eslint-disable-next-line @typescript-eslint/camelcase
            last_name: this.userLastName,
            avatar: this.userRawAvatar,
          },
        };
      } else if (req.type == "getOTP") {
        const response = await api.get("otp");

        res = {
          type: "getOTP",
          data: {
            otp: response.data.otp,
          },
        };
      } else {
        res = req;
      }

      callback(JSON.stringify(res));
    };

      (window as any).getUnityInstance = () => {
      return (this.$refs.unityContainer as any).gameInstance;
    };

  }

  needsOldPlayer() {
    return (
      this.game.url_token == "PasswordNinja" || this.game.url_token == "UrlPunk"
    );
  }

  beforeDestroy() {
    if (this.needsOldPlayer()) {
      (this.$refs.unityContainer as any).gameInstance.Quit();
    } else {
      const gameInstance = (this.$refs.unityContainer as any).getGameInstance();
      if (gameInstance !== null) {
        gameInstance.Quit();
      }
    }

    try {
      (window as any).unityInstance = null;
      delete (window as any).unityInstance;
    } catch (err) {
      console.error(err);
    }

    try {
      delete (window as any).g;
      delete (window as any).HTMLOverlayers;
    } catch (err) {
      console.error(err);
    }
    if(this.originalAlert != null){
      window.alert = this.originalAlert;
      this.originalAlert = null;
    }
  }

  calculateHash(score: number) {
    let hash = `${score + 9999999}|${this.userId}|${this.game.id}`;
    hash = `${(Vue as any).CryptoJS.MD5(hash)}`;
    hash = `${(Vue as any).CryptoJS.MD5(hash)}`;
    let reversedHash = "";
    for (let index = 0; index < hash.length; index++) {
      reversedHash = `${hash[index]}${reversedHash}`;
    }
    hash = reversedHash;
    hash = `${(Vue as any).CryptoJS.MD5(hash)}`;
    hash = `${(Vue as any).CryptoJS.MD5(hash)}`;
    return hash;
  }
}
